// extracted by mini-css-extract-plugin
module.exports = {"item":"Choice_item__qm_Dp","number":"Choice_number__3gZPP"};